import React from "react";
import camelCase from "camel-case";
import { compose, withHandlers } from "recompose";

import sdk from "src/sdk";

import { Box } from "src/components";
import { DynamicForm } from "src/components/Form";
import { mergeWithFieldValidation } from "src/components/Form/validation";
import { useBankingContent } from "src/banking/BankingContentContext";
import { Body } from "src/components/Content";

import {
  verificationFields,
  ssnField,
} from "src/banking/authentication/sharedFields";
import { verficationFieldsValidator } from "src/banking/authentication/validation";

import { BoxWithKeyboardPadding } from "src/banking/components";

const entryFormFieldProps = {
  labelTop: true,
  renderErrorBelow: true,
  autoComplete: "off",
};

const fields = ({ t }) => [
  {
    type: "section",
    title: "Your account",
    fields: [
      {
        key: "acn",
        label: "Member Number",
        required: true,
        inputProps: {
          format: value => {
            // Strip out non-numeric values
            const digits = (value || "").match(/\d/g) || [];
            return digits.join("");
          },
          ...entryFormFieldProps,
        },
      },
      [
        {
          key: "firstName",
          label: "First Name",
          required: true,
          inputProps: {
            ...entryFormFieldProps,
            autoCorrect: "off",
            spellCheck: "off",
          },
        },
        {
          key: "lastName",
          label: "Last Name",
          required: true,
          inputProps: {
            ...entryFormFieldProps,
            autoCorrect: "off",
            spellCheck: "off",
          },
        },
      ],
      {
        key: "email",
        label: "Email Address",
        required: true,
        inputProps: {
          ...entryFormFieldProps,
          type: "email",
        },
        constraints: {
          email: {
            message: "invalid",
          },
        },
      },
      ssnField({
        t,
        inputProps: {
          ...entryFormFieldProps,
          allowToggleVisibility: true,
        },
      }),
    ],
  },
  ...verificationFields({
    t,
    inputProps: {
      ...entryFormFieldProps,
    },
  }),
];

const enhance = compose(
  withHandlers({
    onSubmit: props => async data => {
      //remove leading zeros from acn
      const adjustedAcn = data.acn.replace(/^0+/, "");
      const verifyResult = await sdk.verifyEnrollment(data);
      props.setDefaultValues({
        ...props.defaultValues,
      });
      props.setEnrollmentState({
        ...props.enrollmentState,
        createCredentialsPath: verifyResult.links.security,
        resendSecurityCodePath: verifyResult.links.resendCode,
        showDisclosureInterrupt: true,
        firstName: data.firstName,
        lastName: data.lastName,
        accountNumber: adjustedAcn,
        key: camelCase(verifyResult.state),
      });
    },
  })
);

const initialValues = {
  ssn: "",
  recaptcha: "string",
};

const EnrollmentEntryForm = props => {
  const pageData = useBankingContent();
  return (
    <BoxWithKeyboardPadding>
      {pageData.enrollmentPageContent ? (
        <Body padded={false} content={pageData.enrollmentPageContent.content} />
      ) : null}
      <DynamicForm
        formKey="enrollment"
        fields={fields}
        initialValues={initialValues}
        needsCaptcha={false}
        customValidator={mergeWithFieldValidation(verficationFieldsValidator)}
        {...props}
      />
    </BoxWithKeyboardPadding>
  );
};

export default enhance(EnrollmentEntryForm);



// WEBPACK FOOTER //
// ./src/banking/authentication/Enroll/steps/Entry.js